<template lang="pug">
  v-flex(justify="center")
    v-card.center.fontText(class="mx-auto" max-width="580" align-center raised)
      v-list-item.center(three-line)
        div(class="row")
          div(class="col-7")
            h2.fontTitle(style="margin-top: 40px; font-weight-bold;" ) Detalle Compra
          div(class="col-5")
            img(
              :src="brand.logo"
              width="200"
              style="margin-right: 100px;"
            )
          v-list-item-content(style="margin-left: 30px;" v-if="!load")
            v-list-item-subtitle Nombre Curso: {{ dataTransaction.courseName }}
            v-list-item-content
            v-list-item-subtitle Nombre: {{ dataTransaction.name }} {{ dataTransaction.lastName }}
            v-list-item-subtitle Rut: {{ dataTransaction.rut }}
            v-list-item-content(v-if="dataTransaction.registrationType")
            v-list-item-subtitle(v-if="dataTransaction.registrationType") Empresa: {{ dataTransaction.enterpriseName }}
            v-list-item-subtitle(v-if="dataTransaction.registrationType") Rut Empresa: {{ dataTransaction.enterpriseRut }}
            v-list-item-subtitle(v-if="dataTransaction.registrationType") Giro Empresa: {{ dataTransaction.enterpriseBusinessActivity }}
            v-list-item-subtitle(v-if="dataTransaction.registrationType") Dirección Empresa: {{ dataTransaction.enterpriseAddress }}
            v-list-item-content
            v-list-item-subtitle Valor Curso: {{ dataTransaction.price }} CLP
            v-list-item-subtitle(v-if="dataTransaction.name.price > 5") hola
            v-list-item-subtitle(v-if="dataTransaction.discount !== 0") Descuento: {{ dataTransaction.discount }}% ({{ dataTransaction.discountMount }} CLP)
            v-list-item-subtitle(v-if="dataTransaction.discount !== 0") Total a Pagar: {{ dataTransaction.total }} CLP
            v-spacer
          div.mx-auto(v-if="load" style="margin-top: 150px; margin-bottom: 150px;")
            PulseLoader(color="#8ACA41" class="text-center")
      v-card-actions
        v-btn(rounded class="white--text" :loading="loading" :disabled="disabledButton" color="#81C41D" block @click="goToWebpay()") Ir a WebPay
      v-spacer

    v-dialog(v-model="dialog" persistent max-width="290")
      v-card
        v-card-title(class="headline") Ha ocurrido un error
        v-card-text Por favor vuelva a intentarlo
        v-card-actions
          v-spacer
          v-btn(color="blue" text @click="dialog = false") Volver

</template>

<script>
import appisTransbank from '../../utils/axiosInstances'
import brand from '../../utils/brand'
export default {

  data () {
    return {
      brand,
      dataTransaction: {
        courseName: '',
        date: '',
        schedule: '',
        duration: '',
        price: 0,
        name: '',
        lastName: '',
        amount: 0,
        email: '',
        rut: '',
        discount: 0,
        discountMount: 0,
        total: 0,
        enterpriseName: '',
        enterpriseRut: '',
        enterpriseAddress: '',
        enterpriseBusinessActivity: '',
        registrationType: '',
        buyOrder: ''
      },
      idTransaction: this.$route.query.id_transaccion,
      dialog: false,
      loading: false,
      load: false,
      disabledButton: false
    }
  },
  methods: {
    goBack () {
      window.history.back()
    },
    formatCurrency (amount) {
      const formatAmount = new Intl.NumberFormat('es-CL', { currency: 'CLP', style: 'currency' }).format(amount)
      return formatAmount
    },
    async getAndSetDataPurchase (idTransaction) {
      const response = await appisTransbank.get('/transaction/' + idTransaction)
      if (response.data.paymentDetail.total > 0) {
        this.disabledButton = false
        this.load = false
      } else {
        this.load = true
        window.setTimeout(function () {
          window.location.reload()
        }, 10000)
        this.disabledButton = true
        this.load = true
      }
      this.dataTransaction.name = response.data.user.name
      this.dataTransaction.lastName = response.data.user.lastName
      this.dataTransaction.email = response.data.user.email
      this.dataTransaction.rut = response.data.user.rut
      this.dataTransaction.price = this.formatCurrency(response.data.paymentDetail.realPrice)
      this.dataTransaction.discount = response.data.paymentDetail.discountRate
      this.dataTransaction.total = this.formatCurrency(response.data.paymentDetail.total)
      this.dataTransaction.discountMount = this.formatCurrency(response.data.paymentDetail.discount)
      this.dataTransaction.courseName = response.data.course.title
      this.dataTransaction.buyOrder = response.data.buyOrder
      if (response.data.enterprise) {
        this.dataTransaction.enterpriseName = response.data.enterprise.enterpriseName
        this.dataTransaction.enterpriseRut = response.data.enterprise.enterpriseRut
        this.dataTransaction.enterpriseAddress = response.data.enterprise.enterpriseAddress
        this.dataTransaction.enterpriseBusinessActivity = response.data.enterprise.enterpriseBusinessActivity
        this.dataTransaction.registrationType = response.data.registrationType
      }
    },
    async goToWebpay () {
      try {
        this.loading = true
        const data = {
          id: this.idTransaction
        }
        const response = await appisTransbank.post('/webpay/initTransaction', data)
        window.location.href = response.data.url
      } catch (error) {
        this.loading = false
        this.dialog = true
      }
    }
  },
  async beforeMount () {
    this.load = true
    this.disabledButton = true
    await this.getAndSetDataPurchase(this.idTransaction)
  }
}
</script>

<style lang="stylus">
.fontText{
  font-family: "Montserrat"
}
.fontTitle{
  font-family: "Montserrat-SemiBold"
}
</style>
